// extracted by mini-css-extract-plugin
export default {"DeleteProjectContent__Paragraph":"DeleteProjectForm_DeleteProjectContent__Paragraph__qPtBv"};